import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const SubmitReenrollmentFormMutation = graphql.persisted(
  "SubmitReenrollmentForm",
  graphql(`
    mutation SubmitReenrollmentForm($token: String!, $formData: JSON!) {
      submitReenrollmentForm(input: {token: $token, formData: $formData}) {
        familyEnrollment { id state family { id name } }
        userErrors { message path }
      }
    }
  `)
);

export { SubmitReenrollmentFormMutation };

export function useSubmitReenrollmentForm() {
  return useMutation(SubmitReenrollmentFormMutation);
}
